import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';
import $ from 'jquery';
import {
  apenasNumero,
  apenasLetra,
  renderField, renderFieldCpf, renderFieldTelefone, validarCPF, minTamanhoNome, maxTamanhoNome,
  requiredSelect,
  required
} from '../../util/inputs';
import recuperarPessoaPorCpfCnpj from '../../actions/pessoa/recuperarPessoaPorCpfCnpj';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import { paisesDDI } from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.cpf) {
    errors.cpf = 'Campo obrigatório'
  }
  if (!values.telefone) {
    errors.telefone = 'Campo obrigatório'
  }

  return errors
};

export class DadosComprador extends React.Component {
  constructor (props) {
    super(props);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.submit = this.submit.bind(this);
    this.state = {
      mensagem: { tipo: '', texto: '' },
      arquivo: null
    };
  }

  submit (values) {    
    const comprador = {
      cpfComprador: values.cpf,
      nomeComprador: values.nome,
      telefoneComprador: values.telefone,
      ddiComprador: values.ddiComprador.value ? Number(values.ddiComprador.value) : 32,
    }
    this.props.adicionarDadosComprador(comprador);
    this.fecharModal()
  }

  fecharModal () {
    $('#modalCadastrarDadosComprador')
      .modal('hide');
    $('#modalCadastrarDadosComprador')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.props.reset('formularioCadastrarDadosComprador')
  }

  exibirComboDDI(event) {    
      return (
          <div>
              <Select
                  {...event.input}                  
                  options={paisesDDI.map(elemento => ({
                    label: `${elemento.pais} ${elemento.ddi}`,
                    value: elemento.id
                  }))}
                  onChange={(value) => {
                    this.clearTelefone()
                    event.input.onChange(value);                    
                  }}
              />
              {event.meta.touched
              && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
        </div>
      )    
  }

  clearTelefone() {
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', '');
  }

  alterarAba (aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba (aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formularioCadastrarDadosComprador');
    this.limparMensagem();
  }

  buscarUsuarioPorCpf (cpf) {
    if(apenasNumero(cpf).length === 11){
      this.props.recuperarPessoaPorCpfCnpj(apenasNumero(cpf)).then((resp) => {
        if (resp.payload.data !== '' && resp.payload.status === 200) {
          this.props.changeFieldValue('formularioCadastrarDadosComprador', 'nome', resp.payload.data.nome);
          this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', resp.payload.data.telefone);
        }
      })
    }
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;

    return (
            <div className="modal fade show" role="dialog"
                 id="modalCadastrarDadosComprador" aria-labelledby="modalCadastrarDadosComprador"
                 aria-hidden="true"
                 data-backdrop="static">
                <div className="modal-dialog modal-info modal-md modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Dados de pagamento</h3>
                            <button type="button" className="close" data-dismiss="modal"
                                    id="btnFecharModalCadastrarDadosComprador"
                                    onClick={() => this.limparFormulario()}
                                    aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <h2>Dados do comprador</h2>
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-group">
                                    <Field name="cpf" type="text" component={renderFieldCpf}
                                           label="Número CPF comprador:"
                                           validate={[validarCPF]}
                                           css="form-control col-md-6" readOnly={false}
                                           onBlur={e => this.buscarUsuarioPorCpf(e.target.value)}/>
                                </div>
                                <div className="form-group ">
                                    <Field  name="nome" type="text" component={renderField} 
                                            label="Nome completo:"
                                            validate={[apenasLetra, minTamanhoNome, maxTamanhoNome]}
                                            css="form-control col-md-6" readOnly={false}/>
                                </div>

                                <div className="form-group col-6" style={{marginRight: '0!important', marginLeft: '0!important', paddingRight: '0!important', paddingLeft: '0!important'}}>
                                  <label>Código do País</label>
                                  <Field name='ddiComprador'
                                        validate={requiredSelect} 
                                        component={this.exibirComboDDI.bind(this)} 
                                        css="form-control col-md-6" />                                 
                                </div>

                                {this.props.ddiComprador 
                                    && this.props.ddiComprador.value === 32 ? <div className="form-group">
                                    <Field name="telefone" type="text" component={renderFieldTelefone}
                                           css="form-control col-md-6" label="Telefone"/>
                                </div> :  
                                <><Field name="telefone" type="text" max={15} component={renderField} 
                                    validate={[required]}
                                      css="form-control col-md-6" label="Telefone"/></>}

                                <div className="modal-footer">
                                    <button type="submit" disabled={invalid || submitting || pristine}
                                            className="btn btn-laranja">Salvar
                                    </button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    dadosPagamento: state.dadosPagamento,
    ddiComprador: formValueSelector('formularioCadastrarDadosComprador')(state, 'ddiComprador')    
  }
}

export default connect(mapStateToProps,
  {
    adicionarDadosComprador, recuperarPessoaPorCpfCnpj, changeFieldValue
  })(reduxForm({
  form: 'formularioCadastrarDadosComprador',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(DadosComprador));
